import { Navigate, useLocation } from "react-router-dom";
import { useMe } from "@/hooks/useAuth";
import RouteFallback from "./RouteFallback";

export default function RequireAuth({ children }: { children: React.ReactNode }) {
  const { data: me, isLoading } = useMe();
  const location = useLocation();

  if (isLoading) return <RouteFallback />;
  if (!me) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return <>{children}</>;
}
